var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"10","height":"6","fill":"#974900","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.979.333l-.943.943L4.75 5.99l4.714-4.714-.943-.943L4.75 4.105.979.333z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }